// Plan catalogue as plain data. Types only from the schemas (erased at build),
// so the marketing page can show prices without shipping zod.
import type { PlanMetadata, PlanType } from "./index";

export const PLAN_CONFIGS: Record<PlanType, PlanMetadata> = {
  trial_developer: {
    name: "Developer Trial",
    monthlyPrice: 0,
    quotas: {
      sendLimit: 1000,
      receiveLimit: 10000,
      inboxLimit: 10,
      customDomains: false,
      apiKeysLimit: 3,
    },
    features: [
      "14-day trial",
      "1,000 sends/month",
      "10,000 receives/month",
      "10 inboxes",
      "3 API keys",
      "Email support",
    ],
  },
  developer: {
    name: "Developer",
    monthlyPrice: 20,
    annualPrice: 192,
    quotas: {
      sendLimit: 1000,
      receiveLimit: 10000,
      inboxLimit: 10,
      customDomains: false,
      apiKeysLimit: 3,
    },
    features: [
      "1,000 sends/month",
      "10,000 receives/month",
      "10 inboxes",
      "3 API keys",
      "Email support",
    ],
  },
  startup: {
    name: "Startup",
    monthlyPrice: 200,
    annualPrice: 1920,
    quotas: {
      sendLimit: 25000,
      receiveLimit: 100000,
      inboxLimit: 100,
      customDomains: true,
      apiKeysLimit: 10,
    },
    features: [
      "25,000 sends/month",
      "100,000 receives/month",
      "100 inboxes",
      "Custom domains",
      "10 API keys",
      "Priority support",
      "Webhook delivery",
    ],
  },
  enterprise: {
    name: "Enterprise",
    monthlyPrice: 0,
    quotas: {
      sendLimit: Number.POSITIVE_INFINITY,
      receiveLimit: Number.POSITIVE_INFINITY,
      inboxLimit: Number.POSITIVE_INFINITY,
      customDomains: true,
      apiKeysLimit: Number.POSITIVE_INFINITY,
    },
    features: [
      "Unlimited sends",
      "Unlimited receives",
      "Unlimited inboxes",
      "Custom domains",
      "Unlimited API keys",
      "Dedicated support",
      "Custom SLA",
      "Volume pricing",
    ],
  },
};
